var map = {
	"./payments/724havale.png": [
		50157,
		50157
	],
	"./payments/anindamft.png": [
		98363,
		98363
	],
	"./payments/cepbank.png": [
		39049,
		39049
	],
	"./payments/credit-card.png": [
		31633,
		31633
	],
	"./payments/cryptopay.png": [
		23209,
		23209
	],
	"./payments/etoro-cry.png": [
		43163,
		43163
	],
	"./payments/flex.png": [
		30425,
		30425
	],
	"./payments/hizliqr.png": [
		6807,
		6807
	],
	"./payments/papara.png": [
		26939,
		26939
	],
	"./payments/paybol.png": [
		41531,
		41531
	],
	"./payments/payco.png": [
		90803,
		90803
	],
	"./payments/payfix.png": [
		85129,
		85129
	],
	"./payments/pep.png": [
		31513,
		31513
	],
	"./payments/qr.png": [
		7375,
		7375
	],
	"./payments/safirpapara.png": [
		60244,
		60244
	],
	"./payments/turbohavale.png": [
		58890,
		58890
	],
	"./payments/vevopay-papara.png": [
		74889,
		74889
	],
	"./payments/vevopay-popypara.png": [
		90555,
		90555
	],
	"./payments/vevopay.png": [
		53003,
		53003
	],
	"./payments/zenginsin-cry.png": [
		46766,
		46766
	],
	"./providers/18+.png": [
		69143,
		69143
	],
	"./providers/amatic.png": [
		50636,
		50636
	],
	"./providers/amusnet.png": [
		97274,
		97274
	],
	"./providers/betgamies.png": [
		64163,
		64163
	],
	"./providers/betsoft.png": [
		44996,
		44996
	],
	"./providers/betsolution.png": [
		75698,
		75698
	],
	"./providers/bgamming.png": [
		42976,
		42976
	],
	"./providers/blueprint.png": [
		56116,
		56116
	],
	"./providers/cicogaming.png": [
		59652,
		59652
	],
	"./providers/dlv.png": [
		22263,
		22263
	],
	"./providers/egtdigital.png": [
		198,
		198
	],
	"./providers/elk.png": [
		39201,
		39201
	],
	"./providers/endorphina.png": [
		52977,
		52977
	],
	"./providers/evo.png": [
		42625,
		42625
	],
	"./providers/ezugi.png": [
		91879,
		91879
	],
	"./providers/gameart.png": [
		51719,
		51719
	],
	"./providers/habanero.png": [
		54584,
		54584
	],
	"./providers/igrosoft.png": [
		90377,
		90377
	],
	"./providers/jftw.png": [
		91426,
		91426
	],
	"./providers/netent.png": [
		40694,
		40694
	],
	"./providers/onetouch.png": [
		75640,
		75640
	],
	"./providers/platipus.png": [
		43981,
		43981
	],
	"./providers/playngo.png": [
		80287,
		80287
	],
	"./providers/playson.png": [
		39957,
		67100
	],
	"./providers/pragmaticplay.png": [
		43161,
		43161
	],
	"./providers/quickspin.png": [
		17242,
		17242
	],
	"./providers/redrake.png": [
		84668,
		84668
	],
	"./providers/redtiger.png": [
		21764,
		21764
	],
	"./providers/revolver.png": [
		74513,
		74513
	],
	"./providers/slotagrator.png": [
		26782,
		26782
	],
	"./providers/softswiss.png": [
		1852,
		1852
	],
	"./providers/spadegaming.png": [
		2354,
		2354
	],
	"./providers/spinomnal.png": [
		91251,
		91251
	],
	"./providers/thunderkick.png": [
		7290,
		7290
	],
	"./providers/tomhorn.png": [
		36764,
		36764
	],
	"./providers/triplecherry.png": [
		5212,
		5212
	],
	"./providers/truelab.png": [
		81230,
		19462
	],
	"./providers/tvbet.png": [
		48460,
		48460
	],
	"./providers/wazdan.png": [
		16205,
		16205
	],
	"./providers/yggdrasil.png": [
		5854,
		5854
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36529;
module.exports = webpackAsyncContext;